import type {BasePanel} from '@Components/panel/panel.types';
import type {VideoData} from '@Libraries/add-media-library';

export interface AiVideoPanelProps extends BasePanel {
  onClose?(): void;
  showBackButton?: boolean;
  isFullScreen?: boolean;
  /** Clicks accumulate a multi-selection that the footer's Add Selected delivers at once (e.g. the desktop slideshow picker). Off by default: a clicked video is added to the design immediately. Mobile and fullscreen hosts multi-select regardless. */
  enableMultiSelection?: boolean;
  maxSelectionNumber?: number;
  shouldReplaceOnGenerate?: boolean;
  enableDragToCanvas?: boolean;
  onAddSelected(items: VideoData[]): void | Promise<void>;
}

export enum AiVideoAspectRatio {
  PORTRAIT = '9:16',
  LANDSCAPE = '16:9',
}

export enum AiVideoQuality {
  SD = '720p',
  HD = '1080p',
  UHD = '4K',
}

export enum AiVideoAudio {
  YES = 'yes',
  NO = 'no',
}

export enum AiVideoCameraAngle {
  DEFAULT = 'default',
  TOP_VIEW = 'top_view',
  CLOSE_UP = 'close_up',
  WIDE_SCREEN = 'wide_screen',
  DRAMATIC_ANGLE = 'dramatic_angle',
}

export enum AiVideoTextSetting {
  ON_SCREEN_TEXT = 'on_screen_text',
  CHARACTER_SPEAKS = 'character_speaks',
  VOICEOVER = 'voiceover',
}

export enum AiVideoFilterKey {
  ASPECT_RATIO = 'aspectRatio',
  QUALITY = 'quality',
  AUDIO = 'audio',
  CAMERA_ANGLE = 'cameraAngle',
  TEXT_SETTING = 'textSetting',
}

export const LOADING_KEY_PREFIX = 'ai-video-loading';
export const AI_VIDEO_PROMPT_BOX_ID = 'AI_VIDEO_PROMPT_BOX';
export const DEFAULT_AI_VIDEO_PANEL_ID = 'AI_VIDEO_PANEL';
